import React, { memo } from 'react';
import { DotOrbit, DotOrbitInner } from './styled/DotOrbit';
import DotPlanet from './styled/DotPlanet';

export default memo(function Dot({
  distancePx,
  size,
  opacity,
  item: { singleRevolutionDurMs, angleDegrees },
}) {
  return (
    <DotOrbit
      style={{
        height: distancePx.interpolate(
          [-1, 0, 1, 2],
          ['-2px', '0px', '2px', '4px'],
        ),
        opacity,
        width: distancePx.interpolate(
          [-1, 0, 1, 2],
          ['-2px', '0px', '2px', '4px'],
        ),
      }}
    >
      <DotOrbitInner
        angleDegrees={angleDegrees}
        singleRevolutionDurMs={singleRevolutionDurMs}
      >
        <DotPlanet
          style={{
            height: size.interpolate((x) => `${x}px`),
            width: size.interpolate((x) => `${x}px`),
          }}
        />
      </DotOrbitInner>
    </DotOrbit>
  );
});
